import { SearchIcon } from "@chakra-ui/icons";
import {
  Collapse,
  FormControl,
  FormLabel,
  Input,
  InputGroup,
  InputLeftElement,
  Switch,
} from "@chakra-ui/react";
import { useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";

import { CommentRead } from "@nens/rana/api-v1";

import { RanaMap } from "@/lib/rana-map";

import { CommentThreadList } from "./components/thread-list";
import { UsePublicationCommentReturn } from "./hooks/use-comment";

interface PublicationCommentThreadsOverviewProps {
  commentThreads: CommentRead[] | null;
  selectedCommentThreadId: string | undefined;
  setSelectedCommentThreadId: UsePublicationCommentReturn["setSelectedCommentThreadId"];
  removeCommentThread: UsePublicationCommentReturn["removeCommentThread"];
  editCommentMessage: UsePublicationCommentReturn["editCommentMessage"];
  resolveComment: UsePublicationCommentReturn["resolveComment"];
  toggleCommentReaction: UsePublicationCommentReturn["toggleCommentReaction"];
  showResolved: UsePublicationCommentReturn["showResolved"];
  setShowResolved: UsePublicationCommentReturn["setShowResolved"];
}

export function PublicationCommentThreadsOverview({
  selectedCommentThreadId,
  commentThreads,
  setSelectedCommentThreadId,
  removeCommentThread,
  editCommentMessage,
  resolveComment,
  toggleCommentReaction,
  showResolved,
  setShowResolved,
}: PublicationCommentThreadsOverviewProps) {
  const intl = useIntl();
  const [searchValue, setSearchValue] = useState("");

  return (
    <>
      <Collapse in={!!commentThreads?.length} unmountOnExit>
        <RanaMap.ControlsHeader mb={3}>
          <InputGroup w="full">
            <InputLeftElement pointerEvents="none">
              <SearchIcon color="brand.clear_creek" />
            </InputLeftElement>
            <Input
              id="publication-comments-search"
              placeholder={intl.formatMessage({
                id: "comments.search",
                defaultMessage: "Search",
              })}
              value={searchValue}
              onChange={(e) => setSearchValue(e.target.value)}
            />
          </InputGroup>
        </RanaMap.ControlsHeader>
        <RanaMap.ControlsHeader mt={3} borderBottomWidth="base">
          <FormControl cursor="pointer" gap={2} mb={4} display="flex" alignItems="center">
            <Switch
              isChecked={showResolved}
              onChange={(e) => setShowResolved(e.target.checked)}
              id="show-resolved"
            />
            <FormLabel htmlFor="show-resolved" mb="0">
              <FormattedMessage
                id="comments.show_resolved"
                defaultMessage="Show resolved discussions"
              />
            </FormLabel>
          </FormControl>
        </RanaMap.ControlsHeader>
      </Collapse>

      <CommentThreadList
        showResolved={showResolved}
        searchValue={searchValue}
        commentThreads={commentThreads}
        selectedCommentThreadId={selectedCommentThreadId}
        setSelectedCommentThreadId={setSelectedCommentThreadId}
        removeCommentThread={removeCommentThread}
        editCommentMessage={editCommentMessage}
        resolveComment={resolveComment}
        toggleCommentReaction={toggleCommentReaction}
      />
    </>
  );
}
